import { gql } from '@apollo/client';
import Loading from 'components/Loading';
import NoMatch from 'containers/NoMatch';
import { useQuery } from 'hooks/apollo';
import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { SurveyType } from 'shared/services/prisma/types';

const QUERY = gql`query($id: ID!) { 
  surveyGroup(id: $id) { 
    id 
    type 
    dataSource { id }    
  }
}`;

const RedirectToSurvey = () => {
  const { surveyId } = useParams();
  const { data, loading } = useQuery(QUERY, {
    variables: { id: surveyId },
    skip: !surveyId,
  });

  if (loading) {
    return <Loading />;
  }

  if (!data?.surveyGroup?.dataSource) {
    return <NoMatch />;
  }

  return <Redirect to={`/data-sources/${data.surveyGroup.dataSource.id}/${data.surveyGroup.type === SurveyType.Cx ? 'cx-surveys' : 'ux-surveys'}/surveys/${data.surveyGroup.id}`} />;
};

export default RedirectToSurvey;
